import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import { makeStyles, Box, Container, Typography, Grid } from '@material-ui/core';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import PropTypes__default from 'prop-types';
import clsx from 'clsx';
import { retrieveContentfulImage } from '../../common/image.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    title: {
      marginBottom: theme.spacing(3)
    },
    amenity: {
      background: theme.palette.secondary["50"]
    },
    amenityMobile: {
      background: "#F4F4ED",
      borderRadius: theme.spacing(1)
    },
    img: {
      width: theme.spacing(17.2)
    },
    imgMobile: {
      maxWidth: "-webkit-fill-available",
      width: theme.spacing(9.375)
    },
    mb1: {
      marginBottom: theme.spacing(1)
    },
    mb2: {
      marginBottom: theme.spacing(2)
    },
    mt2: {
      marginTop: theme.spacing(2)
    }
  };
});
var TilesAmenities = function TilesAmenities(_ref) {
  var bgColor = _ref.bgColor,
    gridColumns = _ref.gridColumns,
    gridSpacing = _ref.gridSpacing,
    title = _ref.title,
    items = _ref.items;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isSmallScreen = _useBreakpoints.isSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    bgcolor: bgColor,
    textAlign: "center",
    py: 5
  }, (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/React__default.createElement(Container, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    className: classes.title
  }, title), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: isExtraSmallScreen() || isSmallScreen() ? 3 : gridSpacing
  }, items === null || items === void 0 ? void 0 : items.map(function (amenity) {
    return /*#__PURE__*/React__default.createElement(Grid, {
      item: true,
      md: gridColumns ? 12 / gridColumns : 12,
      lg: gridColumns ? 12 / gridColumns : 12,
      xl: gridColumns ? 12 / gridColumns : 12,
      xs: 6,
      sm: 3,
      key: amenity === null || amenity === void 0 ? void 0 : amenity.title,
      align: "center",
      className: classes.amenityContainer
    }, /*#__PURE__*/React__default.createElement(Box, {
      px: 2,
      height: "100%",
      className: clsx(_defineProperty(_defineProperty({}, classes.amenity, !(isExtraSmallScreen() || isSmallScreen())), classes.amenityMobile, isExtraSmallScreen() || isSmallScreen()))
    }, (amenity === null || amenity === void 0 ? void 0 : amenity.imageUrl) && /*#__PURE__*/React__default.createElement(LazyLoadImage, {
      alt: amenity.imageTitle || "",
      src: retrieveContentfulImage(amenity === null || amenity === void 0 ? void 0 : amenity.imageUrl, isSmallScreen() || isExtraSmallScreen() ? {
        width: 75
      } : {
        width: 138
      }),
      className: clsx(classes.mt2, classes.mb1, _defineProperty(_defineProperty({}, classes.img, !(isExtraSmallScreen() || isSmallScreen())), classes.imgMobile, isExtraSmallScreen() || isSmallScreen()))
    }), /*#__PURE__*/React__default.createElement(Typography, {
      variant: "body2",
      align: "center",
      className: classes.mb2
    }, amenity.title)));
  }))));
};
TilesAmenities.propTypes = {
  bgColor: PropTypes__default.string,
  gridColumns: PropTypes__default.oneOf([1, 2, 3, 4, 6, 12]),
  gridSpacing: PropTypes__default.number,
  title: PropTypes__default.string,
  items: PropTypes__default.arrayOf(PropTypes__default.shape({
    imageUrl: PropTypes__default.string,
    title: PropTypes__default.string
  }))
};

export { TilesAmenities as default };
//# sourceMappingURL=TilesAmenities.js.map
